import { render, staticRenderFns } from "./EventCalendar.vue?vue&type=template&id=033c0dd2&scoped=true"
import script from "./EventCalendar.vue?vue&type=script&lang=ts"
export * from "./EventCalendar.vue?vue&type=script&lang=ts"
import style0 from "./EventCalendar.vue?vue&type=style&index=0&id=033c0dd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033c0dd2",
  null
  
)

export default component.exports